import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs/operators'
import { AuthService } from './auth.service'

export const NoAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.tryRestoreSession().pipe(map(authenticated => (authenticated ? router.parseUrl('/home') : true)))
}
